import { IPage } from "@/types/AppTypes";
import { httpRequest } from "@/utils/HttpRequest";
import { ISosDetail, ISosSearch } from "./sosTypes";


class SosService {
    async page(searchVo: ISosSearch, config: object = {}) {
        const apiUrl = "/gtm/statistical/quotationSuccessRate";
        return await httpRequest.post<IPage<ISosDetail>>(apiUrl, searchVo, config);
    }
    //导出
    async export(searchVo: ISosSearch) {
        const appPageUrl = "/gtm/statistical/quotationSuccessRate/export";
        return await httpRequest.postFile<boolean>(appPageUrl, searchVo, { timeout: 300000 });
    }

}

export const sosService = new SosService();
